import { Pipe, PipeTransform } from '@angular/core';
import { NgxExcelSelectOption } from '../models/models';

@Pipe({
    name: 'ngxExcelSelectOption'
})

export class NgxExcelSelectOptionPipe implements PipeTransform {

    /**
     * æ¾ç¤ºéé¡¹æéé¡¹åè¡¨
     * @param value SelectOption å¯¹è±¡æå¯¹è±¡åè¡¨
     * @param count æå¤æ¸²æçå¯¹è±¡æ°é
     */
    transform(value: NgxExcelSelectOption | NgxExcelSelectOption[], count?: number): string {
        if (!Array.isArray(value)) {
            value = [ value ];
        }
        return value.slice(0, count || value.length).map((item: NgxExcelSelectOption) => item.label).join('ï¼');
    }
}
